import fs from 'node:fs';
import path from 'node:path';
import type { BootstrapSessionState } from './bootstrap-state.js';

const DEV_VARS_FILENAME = '.dev.vars';

export const PROJECT_AUTH_ENV_KEYS = [
  'STANDARDAGENTS_ORG_ACCOUNT_ID',
  'STANDARDAGENTS_ORG_USER_ID',
  'STANDARDAGENTS_ORG_SLUG',
  'STANDARDAGENTS_BOOTSTRAP_SESSION_COOKIE',
] as const;

function upsertEnvLine(lines: string[], key: string, value: string): void {
  const nextLine = `${key}=${value}`;
  const index = lines.findIndex((line) => line.startsWith(`${key}=`));
  if (index >= 0) {
    lines[index] = nextLine;
    return;
  }
  lines.push(nextLine);
}

export function syncProjectAuthEnv(
  projectPath: string,
  endpoint: string,
  state: BootstrapSessionState,
): void {
  const devVarsPath = path.join(projectPath, DEV_VARS_FILENAME);
  const existing = fs.existsSync(devVarsPath)
    ? fs.readFileSync(devVarsPath, 'utf-8')
    : '';

  const lines = existing ? existing.split('\n') : [];

  if (endpoint.trim()) {
    upsertEnvLine(lines, 'PLATFORM_ENDPOINT', endpoint.trim());
  }

  upsertEnvLine(lines, 'STANDARDAGENTS_ORG_ACCOUNT_ID', state.account.id);
  upsertEnvLine(lines, 'STANDARDAGENTS_ORG_USER_ID', state.user.id);
  if (state.account.slug) {
    upsertEnvLine(lines, 'STANDARDAGENTS_ORG_SLUG', state.account.slug);
  }
  if (state.session_cookie) {
    upsertEnvLine(lines, 'STANDARDAGENTS_BOOTSTRAP_SESSION_COOKIE', state.session_cookie);
  }

  const normalized = lines.join('\n').replace(/\n*$/, '\n');
  fs.writeFileSync(devVarsPath, normalized, 'utf-8');
}
